(function() {
  'use strict';

  function initTestimonialVideoSlider() {
    const section = document.querySelector('.testimonial-video-section');
    if (!section) return;

    const slider = section.querySelector('.testimonial-video-section__slider');
    const slides = section.querySelectorAll('.testimonial-video-section__slide');
    const prevButton = section.querySelector('#testimonial-video-prev');
    const nextButton = section.querySelector('#testimonial-video-next');
    const dotsContainer = section.querySelector('#testimonial-video-dots');

    if (!slider || slides.length === 0) {
      console.warn('Slider or slides not found');
      return;
    }

    let currentIndex = 0;
    const totalSlides = slides.length;
    let isMobile = window.innerWidth < 1120;

    // Create dots navigation for mobile
    function createDots() {
      if (!dotsContainer || !isMobile) return;
      
      // Clear existing dots
      dotsContainer.innerHTML = '';
      
      // Create a dot for each slide
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('li');
        const button = document.createElement('button');
        button.className = 'testimonial-video-section__slider-dot';
        button.setAttribute('aria-label', `Go to slide ${i + 1}`);
        button.setAttribute('data-slide-index', i.toString());
        
        if (i === 0) {
          button.classList.add('testimonial-video-section__slider-dot--active');
        }
        
        button.addEventListener('click', function() {
          const slideIndexAttr = this.getAttribute('data-slide-index');
          const targetIndex = slideIndexAttr ? parseInt(slideIndexAttr, 10) : 0;
          currentIndex = targetIndex;
          updateSlides();
          updateDots();
          pauseAllVideos();
        });
        
        dot.appendChild(button);
        dotsContainer.appendChild(dot);
      }
    }

    // Update dots to show active one
    function updateDots() {
      if (!dotsContainer || !isMobile) return;
      const dots = dotsContainer.querySelectorAll('.testimonial-video-section__slider-dot');
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('testimonial-video-section__slider-dot--active');
        } else {
          dot.classList.remove('testimonial-video-section__slider-dot--active');
        }
      });
    }

    // Initialize slides
    function initializeSlides() {
      // Remove all state classes first
      slides.forEach((slide, index) => {
        slide.classList.remove('testimonial-video-section__slide--active', 'testimonial-video-section__slide--next', 'testimonial-video-section__slide--third');
      });
      
      // Reset current index to 0
      currentIndex = 0;
      
      // Update slides to show correct ones
      updateSlides();
      
      // Hide slides beyond the first 3
      slides.forEach((slide, index) => {
        if (index >= 3) {
          const hasActiveClass = slide.classList.contains('testimonial-video-section__slide--active') ||
                                 slide.classList.contains('testimonial-video-section__slide--next') ||
                                 slide.classList.contains('testimonial-video-section__slide--third');
          if (!hasActiveClass) {
            const slideElement = /** @type {HTMLElement} */ (slide);
            slideElement.style.display = 'none';
            slideElement.style.opacity = '0';
          }
        }
      });
    }

    // Update visible slides based on current index
    function updateSlides() {
      // Remove all state classes first
      slides.forEach((slide, index) => {
        slide.classList.remove('testimonial-video-section__slide--active', 'testimonial-video-section__slide--next', 'testimonial-video-section__slide--third');
        // Reset inline styles
        const slideElement = /** @type {HTMLElement} */ (slide);
        slideElement.style.display = '';
        slideElement.style.opacity = '';
      });

      // Update play buttons visibility - show on all visible slides (active, next, third)
      const activeIndex = currentIndex % totalSlides;
      const nextIndex = totalSlides > 1 ? (currentIndex + 1) % totalSlides : -1;
      const thirdIndex = totalSlides > 2 ? (currentIndex + 2) % totalSlides : -1;
      
      slides.forEach((slide, index) => {
        const playButton = slide.querySelector('.testimonial-video-section__play-button');
        if (playButton) {
          const playButtonElement = /** @type {HTMLElement} */ (playButton);
          // Check if this slide is one of the visible ones (active, next, or third)
          const isVisibleSlide = index === activeIndex || index === nextIndex || index === thirdIndex;
          
          if (isVisibleSlide) {
            // Visible slide - show play button (unless video is playing)
            const video = slide.querySelector('.testimonial-video-section__video');
            const videoEmbed = slide.querySelector('.testimonial-video-section__video-embed');
            const hasIframe = videoEmbed && videoEmbed.querySelector('iframe');
            
            if ((video && video instanceof HTMLVideoElement && !video.paused) || hasIframe) {
              playButtonElement.classList.add('testimonial-video-section__play-button--hidden');
            } else {
              playButtonElement.classList.remove('testimonial-video-section__play-button--hidden');
            }
          } else {
            // Non-visible slide - hide play button
            playButtonElement.classList.add('testimonial-video-section__play-button--hidden');
          }
        }
      });

      if (isMobile) {
        // Mobile: Active slide on top (full width), next 2 below in a row
        // Active slide
        const activeIndex = currentIndex % totalSlides;
        if (slides[activeIndex]) {
          slides[activeIndex].classList.add('testimonial-video-section__slide--active');
        }

        // Next slide (first in bottom row)
        if (totalSlides > 1) {
          const nextIndex = (currentIndex + 1) % totalSlides;
          if (slides[nextIndex]) {
            slides[nextIndex].classList.add('testimonial-video-section__slide--next');
          }
        }

        // Third slide (second in bottom row)
        if (totalSlides > 2) {
          const thirdIndex = (currentIndex + 2) % totalSlides;
          if (slides[thirdIndex]) {
            slides[thirdIndex].classList.add('testimonial-video-section__slide--third');
          }
        }

        // Hide all other slides on mobile
        slides.forEach((slide, index) => {
          const activeIndex = currentIndex % totalSlides;
          const nextIndex = totalSlides > 1 ? (currentIndex + 1) % totalSlides : -1;
          const thirdIndex = totalSlides > 2 ? (currentIndex + 2) % totalSlides : -1;
          
          if (index !== activeIndex && index !== nextIndex && index !== thirdIndex) {
            const slideElement = /** @type {HTMLElement} */ (slide);
            slideElement.style.display = 'none';
            slideElement.style.opacity = '0';
          }
        });

        // Update dots
        updateDots();
      } else {
        // Desktop: 2 on top, 1 below
        // Active slide (top left, bigger)
        const activeIndex = currentIndex % totalSlides;
        if (slides[activeIndex]) {
          slides[activeIndex].classList.add('testimonial-video-section__slide--active');
        }

        // Next slide (top right)
        if (totalSlides > 1) {
          const nextIndex = (currentIndex + 1) % totalSlides;
          if (slides[nextIndex]) {
            slides[nextIndex].classList.add('testimonial-video-section__slide--next');
          }
        }

        // Third slide (bottom center)
        if (totalSlides > 2) {
          const thirdIndex = (currentIndex + 2) % totalSlides;
          if (slides[thirdIndex]) {
            slides[thirdIndex].classList.add('testimonial-video-section__slide--third');
          }
        }

        // Hide all other slides on desktop
        slides.forEach((slide, index) => {
          const activeIndex = currentIndex % totalSlides;
          const nextIndex = totalSlides > 1 ? (currentIndex + 1) % totalSlides : -1;
          const thirdIndex = totalSlides > 2 ? (currentIndex + 2) % totalSlides : -1;
          
          if (index !== activeIndex && index !== nextIndex && index !== thirdIndex) {
            const slideElement = /** @type {HTMLElement} */ (slide);
            slideElement.style.display = 'none';
            slideElement.style.opacity = '0';
          }
        });
      }
    }

    // Navigate to next slide
    function nextSlide() {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlides();
      pauseAllVideos();
      if (isMobile) {
        updateDots();
      }
    }

    // Navigate to previous slide
    function prevSlide() {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlides();
      pauseAllVideos();
      if (isMobile) {
        updateDots();
      }
    }

    // Helper function to attempt playing video
    /**
     * @param {HTMLVideoElement} video
     * @param {HTMLElement} playButton
     */
    function attemptPlay(video, playButton) {
      // Check if video has a source
      if (!video.currentSrc && !video.src) {
        console.error('Video has no source to play!');
        playButton.classList.remove('testimonial-video-section__play-button--hidden');
        video.controls = true;
        return;
      }
      
      // Load video if not loaded
      if (video.readyState < 2) {
        video.load();
        // Wait a bit for video to load
        const checkReady = function() {
          if (video.readyState >= 2) {
            playVideo(video, playButton);
          } else {
            setTimeout(checkReady, 100);
          }
        };
        setTimeout(checkReady, 200);
      } else {
        playVideo(video, playButton);
      }
    }

    // Helper function to actually play the video
    /**
     * @param {HTMLVideoElement} video
     * @param {HTMLElement} playButton
     */
    function playVideo(video, playButton) {
      // Final check before playing
      if (!video.currentSrc && !video.src) {
        console.error('Cannot play: video has no source!');
        playButton.classList.remove('testimonial-video-section__play-button--hidden');
        video.controls = true;
        return;
      }
      
      // Pause all other videos before playing this one
      pauseAllVideos(video);
      
      // Play video with error handling
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video is playing
            playButton.classList.add('testimonial-video-section__play-button--hidden');
            video.controls = false;
          })
          .catch((error) => {
            // Video play failed (e.g., autoplay policy)
            console.error('Error playing video:', error);
            // Show play button again
            playButton.classList.remove('testimonial-video-section__play-button--hidden');
            // Try to show native controls as fallback
            video.controls = true;
            alert('Unable to play video automatically. Please use the video controls to play.');
          });
      } else {
        // Fallback for older browsers
        try {
          video.play();
          playButton.classList.add('testimonial-video-section__play-button--hidden');
        } catch (err) {
          console.error('Error playing video (fallback):', err);
          playButton.classList.remove('testimonial-video-section__play-button--hidden');
          video.controls = true;
        }
      }

      // Show play button again when video ends
      video.addEventListener('ended', function() {
        playButton.classList.remove('testimonial-video-section__play-button--hidden');
        video.controls = false;
      }, { once: true });

      // Show play button if video is paused (but not if it just started)
      video.addEventListener('pause', function() {
        if (video.currentTime > 0 && !video.ended) {
          playButton.classList.remove('testimonial-video-section__play-button--hidden');
        }
      });

      // Handle video playing state
      video.addEventListener('playing', function() {
        playButton.classList.add('testimonial-video-section__play-button--hidden');
        video.controls = false;
      });
    }

    // Pause all videos except the one specified
    /**
     * @param {HTMLVideoElement|HTMLElement} [exceptVideo] - Video or video embed to exclude from pausing
     */
    function pauseAllVideos(exceptVideo) {
      if (!section) return;
      const videos = section.querySelectorAll('.testimonial-video-section__video');
      videos.forEach(video => {
        if (video instanceof HTMLVideoElement && video !== exceptVideo) {
          video.pause();
          video.currentTime = 0;
          // Ensure poster image shows again when video is paused
          video.load();
        }
      });

      // Reset play buttons (except for the video that's playing)
      const playButtons = section.querySelectorAll('.testimonial-video-section__play-button');
      playButtons.forEach(button => {
        // Don't hide the play button for the video that's currently playing
        const videoWrapper = button.closest('.testimonial-video-section__video-wrapper');
        if (videoWrapper) {
          const videoInWrapper = videoWrapper.querySelector('.testimonial-video-section__video');
          const videoEmbed = videoWrapper.querySelector('.testimonial-video-section__video-embed');
          
          // Check if this is the video that's currently playing
          const isPlayingVideo = (videoInWrapper === exceptVideo) || 
                                (videoEmbed && videoEmbed === exceptVideo) ||
                                (videoEmbed && videoEmbed.querySelector('iframe') && exceptVideo && exceptVideo.closest && exceptVideo.closest('.testimonial-video-section__video-embed') === videoEmbed);
          
          if (!isPlayingVideo) {
            button.classList.remove('testimonial-video-section__play-button--hidden');
          }
        } else {
          button.classList.remove('testimonial-video-section__play-button--hidden');
        }
      });

      // Handle YouTube/Vimeo iframes - restore thumbnails for paused videos
      const videoEmbeds = section.querySelectorAll('.testimonial-video-section__video-embed');
      videoEmbeds.forEach(embed => {
        const iframe = embed.querySelector('iframe');
        const thumbnail = embed.querySelector('.testimonial-video-section__video-thumbnail');
        
        // Check if this is the video that's currently playing
        const isPlayingEmbed = (embed === exceptVideo) || 
                               (exceptVideo && exceptVideo.closest && exceptVideo.closest('.testimonial-video-section__video-embed') === embed);
        
        if (iframe && !isPlayingEmbed) {
          // Remove iframe and restore thumbnail for paused embedded videos
          iframe.remove();
          if (thumbnail) {
            const thumbnailElement = /** @type {HTMLElement} */ (thumbnail);
            thumbnailElement.style.display = 'block';
          } else {
            // Recreate thumbnail if it was removed
            const videoUrl = embed.getAttribute('data-video-url');
            if (videoUrl) {
              let thumbnailSrc = '';
              if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
                let videoId = '';
                if (videoUrl.includes('youtube.com')) {
                  const urlParams = videoUrl.split('v=');
                  if (urlParams && urlParams.length > 1) {
                    const videoIdPart = urlParams[1];
                    if (videoIdPart) {
                      const parts = videoIdPart.split('&');
                      if (parts && parts.length > 0 && parts[0]) {
                        const firstPart = parts[0];
                        const questionParts = firstPart.split('?');
                        videoId = (questionParts && questionParts.length > 0 && questionParts[0]) ? questionParts[0] : '';
                      }
                    }
                  }
                } else if (videoUrl.includes('youtu.be')) {
                  const urlParts = videoUrl.split('youtu.be/');
                  if (urlParts && urlParts.length > 1) {
                    const videoIdPart = urlParts[1];
                    if (videoIdPart) {
                      videoId = videoIdPart.split('?')[0] || '';
                    }
                  }
                }
                if (videoId) {
                  thumbnailSrc = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                }
              } else if (videoUrl.includes('vimeo.com')) {
                const urlParts = videoUrl.split('vimeo.com/');
                const videoId = urlParts[1]?.split('?')[0]?.split('/')[0] || '';
                if (videoId) {
                  thumbnailSrc = `https://vumbnail.com/${videoId}.jpg`;
                }
              }
              
              if (thumbnailSrc) {
                const img = document.createElement('img');
                img.src = thumbnailSrc;
                img.className = 'testimonial-video-section__video-thumbnail';
                img.alt = 'Video thumbnail';
                embed.appendChild(img);
              }
            }
          }
        }
      });
    }

    // Navigation button event listeners
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        prevSlide();
      });
    } else {
      console.warn('Prev button not found');
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        nextSlide();
      });
    } else {
      console.warn('Next button not found');
    }

    // Create popup modal structure
    function createVideoPopup() {
      // Check if popup already exists
      let popup = document.querySelector('.testimonial-video-popup');
      if (popup) {
        return popup;
      }

      // Create popup overlay
      const popupOverlay = document.createElement('div');
      popupOverlay.className = 'testimonial-video-popup';
      popupOverlay.innerHTML = `
        <div class="testimonial-video-popup__overlay"></div>
        <div class="testimonial-video-popup__content">
          <button class="testimonial-video-popup__close" aria-label="Close video popup">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="testimonial-video-popup__video-wrapper"></div>
        </div>
      `;
      document.body.appendChild(popupOverlay);

      // Close popup handlers
      const closeBtn = popupOverlay.querySelector('.testimonial-video-popup__close');
      const overlay = popupOverlay.querySelector('.testimonial-video-popup__overlay');
      
      function closePopup() {
        popupOverlay.classList.remove('testimonial-video-popup--active');
        const videoWrapper = popupOverlay.querySelector('.testimonial-video-popup__video-wrapper');
        if (videoWrapper) {
          videoWrapper.innerHTML = '';
        }
        document.body.style.overflow = '';
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
      }
      if (overlay) {
        overlay.addEventListener('click', closePopup);
      }

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupOverlay.classList.contains('testimonial-video-popup--active')) {
          closePopup();
        }
      });

      return popupOverlay;
    }

    // Video play functionality - show popup instead of inline play
    const playButtons = section.querySelectorAll('.testimonial-video-section__play-button');
    
    playButtons.forEach((playButton, btnIndex) => {
      playButton.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        // Get popup content from data attribute
        const popupContent = this.getAttribute('data-video-popup');
        if (!popupContent) {
          console.warn('No popup content found');
          return;
        }

        // Create and show popup
        const popup = createVideoPopup();
        const videoWrapper = popup.querySelector('.testimonial-video-popup__video-wrapper');
        
        if (!videoWrapper) {
          console.error('Video wrapper not found in popup');
          return;
        }
        
        // Decode HTML entities and insert content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = popupContent;
        videoWrapper.innerHTML = '';
        const contentElement = tempDiv.firstElementChild || tempDiv;
        if (contentElement) {
          videoWrapper.appendChild(contentElement);
        }
        
        // Show popup
        popup.classList.add('testimonial-video-popup--active');
        document.body.style.overflow = 'hidden';

        // Auto-play video if it's a video element
        setTimeout(() => {
          const video = videoWrapper.querySelector('video');
          if (video) {
            // Ensure autoplay attribute is set
            video.setAttribute('autoplay', '');
            video.setAttribute('playsinline', '');
            video.play().catch(function() {});
          }

          // For iframes (YouTube/Vimeo), ensure autoplay is in URL
          const iframe = videoWrapper.querySelector('iframe');
          if (iframe) {
            if (!iframe.src.includes('autoplay=1')) {
              const separator = iframe.src.includes('?') ? '&' : '?';
              iframe.src += separator + 'autoplay=1';
            }
          }
        }, 100);
      });
    });

    // Old inline video code removed - now using popup modal

    // Handle video click to pause/play (optional - can be removed if not needed)
    if (section) {
      const videos = section.querySelectorAll('.testimonial-video-section__video');
      videos.forEach(video => {
        if (video instanceof HTMLVideoElement) {
          video.addEventListener('click', function(e) {
            e.stopPropagation();
            const videoWrapper = this.closest('.testimonial-video-section__video-wrapper');
            const playButton = videoWrapper ? videoWrapper.querySelector('.testimonial-video-section__play-button') : null;
            
            if (this.paused) {
              // Pause all other videos before playing this one
              pauseAllVideos(this);
              
              const playPromise = this.play();
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    if (playButton) {
                      playButton.classList.add('testimonial-video-section__play-button--hidden');
                    }
                  })
                  .catch((error) => {
                    console.error('Error playing video on click:', error);
                    if (playButton) {
                      playButton.classList.remove('testimonial-video-section__play-button--hidden');
                    }
                  });
              }
            } else {
              this.pause();
              if (playButton) {
                playButton.classList.remove('testimonial-video-section__play-button--hidden');
              }
            }
          });
        }
      });
    }

    // Handle window resize
    function handleResize() {
      const wasMobile = isMobile;
      isMobile = window.innerWidth < 768;
      
      if (wasMobile !== isMobile) {
        // Create or remove dots based on mobile state
        if (isMobile) {
          createDots();
        } else if (dotsContainer) {
          dotsContainer.innerHTML = '';
        }
        updateSlides();
      }
    }

    // Initialize
    initializeSlides();
    if (isMobile) {
      createDots();
    }

    // Listen for resize events
    /** @type {number|undefined} */ let resizeTimeout;
    window.addEventListener('resize', function() {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(handleResize, 250);
    });

    // Keyboard navigation (optional)
    document.addEventListener('keydown', function(e) {
      if (!section.contains(document.activeElement) && document.activeElement !== document.body) {
        return;
      }

      if (e.key === 'ArrowLeft' && prevButton) {
        e.preventDefault();
        prevSlide();
      } else if (e.key === 'ArrowRight' && nextButton) {
        e.preventDefault();
        nextSlide();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialVideoSlider);
  } else {
    initTestimonialVideoSlider();
  }
})();

